module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jesse Bullington\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Jesse Bullington")]), _vm._v(" spent the bulk of his formative years in rural Pennsylvania, the Netherlands, and Tallahassee, Florida.  He is a folklore and outdoor enthusiast who holds a bachelor's degree in History and English Literature from Florida State University.  He currently resides in Colorado, and his blog, as well as fan art, news and exclusive content can be found at www.jessebullington.com.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16jYaXM/images/9780316071925.jpg?1733067555104",
      "alt": "This image is the cover for the book Sad Tale of the Brothers Grossbart"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sad Tale of the Brothers Grossbart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Hegel and Manfried Grossbart may not consider themselves bad men -- but death still stalks them through the dark woods of medieval Europe. "), _c('br'), _c('br'), _vm._v("The year is 1364, and the brothers Grossbart have embarked on a naïve quest for fortune. Descended from a long line of graverobbers, they are determined to follow their family's footsteps to the fabled crypts of Gyptland. To get there, they will have to brave dangerous and unknown lands and keep company with all manner of desperate travelers-merchants, priests, and scoundrels alike. For theirs is a world both familiar and distant; a world of living saints and livelier demons, of monsters and madmen. "), _c('br'), _c('br'), _vm._v("The Brothers Grossbart are about to discover that all legends have their truths, and worse fates than death await those who would take the red road of villainy.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit/Yen\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0